<button class="iconf-btn-blank user-container" (click)="toggleSidebar()">
  <div class="user-image-container">
    @if (userImage$ | async; as userImage) {
    <img [src]="userImage" class="user-photo" />
    } @else {
    <mat-icon class="user-photo-placeholder">person</mat-icon>
    }
  </div>
  @if (currentUserProfile$ | async; as currentUserProfile) {
  <div class="user-info">
    {{ currentUserProfile.name }}
  </div>
  }
  <mat-icon>more_vert</mat-icon>
</button>
